import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=50363be2&scoped=true"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=50363be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50363be2",
  null
  
)

export default component.exports